import React, { useRef, useState } from 'react';
import './AddNewProductss.scss';

export default function AddNewProductss() {
  const [tags, setTags] = useState(['FURNITURE']);
  const [images, setImages] = useState([]);
  const fileInputRef = useRef();

  const handleTagRemove = (idx) => {
    setTags(tags.filter((_, i) => i !== idx));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages([...images, ...files.map(file => URL.createObjectURL(file))]);
  };

  return (
    <div className="add-productss-container">
      <form className="add-productss-form row">
        {/* العمود الأيسر */}
        <div className="col left-col">
          <div className="card-section">
            <div className="form-group">
              <label>PRODUCT NAME</label>
              <input type="text" placeholder="Enter Product Name" />
            </div>
            <div className="form-group">
              <label>PRODUCT DESCRIPTION</label>
              <input type="text" placeholder="Enter Product Description" />
            </div>
          </div>
          <div className="card-section">
            <div className="form-group">
              <label>PRODUCT CATEGORY</label>
              <select>
                <option>Select Category</option>
                <option>Furniture</option>
                <option>Electronics</option>
                <option>Clothes</option>
              </select>
            </div>
            <div className="form-group">
              <label>PRODUCT TAGS</label>
              <div className="tags-input">
                {tags.map((tag, idx) => (
                  <span className="tag" key={idx}>
                    {tag}
                    <button type="button" onClick={() => handleTagRemove(idx)}>&times;</button>
                  </span>
                ))}
                {/* إضافة تاجز ديناميكي لاحقًا */}
              </div>
            </div>
            <div className="form-group">
              <label>PRODUCT SHORT DESCRIPTION</label>
              <input type="text" placeholder="Add short description for product" />
            </div>
          </div>
          <div className="card-section">
            <div className="form-group">
              <label>STATUS</label>
              <select>
                <option>Published</option>
                <option>Draft</option>
              </select>
            </div>
            <div className="form-group">
              <label>PUBLISH SCHEDULE</label>
              <input type="datetime-local" />
            </div>
            <div className="form-group">
              <label>VISIBILITY</label>
              <select>
                <option>Public</option>
                <option>Private</option>
              </select>
            </div>
          </div>
        </div>
        {/* العمود الأيمن */}
        <div className="col right-col">
          <div className="card-section">
            <div className="form-group">
              <label>MANUFACTURER NAME</label>
              <input type="text" placeholder="Enter Manufacturer Name" />
            </div>
            <div className="form-group">
              <label>MANUFACTURER BRAND</label>
              <input type="text" placeholder="Enter Manufacturer Brand" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>STOCKS</label>
                <input type="number" placeholder="Stocks" />
              </div>
              <div className="form-group">
                <label>PRICE, $</label>
                <input type="number" placeholder="Price" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>DISCOUNT, %</label>
                <input type="number" placeholder="Discount" />
              </div>
              <div className="form-group">
                <label>LABEL</label>
                <input type="text" placeholder="Label words" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>LABEL COLOR</label>
                <select>
                  <option>Choose the label color</option>
                  <option>Red</option>
                  <option>Blue</option>
                  <option>Green</option>
                </select>
              </div>
              <div className="form-group">
                <label>LABEL SIZE</label>
                <select>
                  <option>Choose label size</option>
                  <option>Small</option>
                  <option>Medium</option>
                  <option>Large</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card-section">
            <label className="gallery-label">Product Gallery</label>
            <div className="gallery-upload">
              <div className="upload-box" onClick={() => fileInputRef.current.click()}>
                <input type="file" multiple ref={fileInputRef} style={{ display: 'none' }} onChange={handleImageChange} />
                <span className="upload-icon">&#8682;</span>
                <span className="upload-text">Drop files here or click to upload<br/>175x207</span>
              </div>
              <div className="gallery-images">
                {images.map((img, idx) => (
                  <div className="gallery-img" key={idx}>
                    <img src={img} alt="product" />
                  </div>
                ))}
                <div className="gallery-img add-more" onClick={() => fileInputRef.current.click()}>+</div>
              </div>
            </div>
          </div>
        </div>
      </form>
           <div className="form-buttons">
          <button type="submit" className="publish">PUBLISH</button>
          <button type="button" className="cancel">CANCEL</button>
        </div>
    </div>
  );
} 